<template>
  <div>
    <p class="w-full my-6 sm:w-auto">
      This will remove <span class="font-semibold">{{ employee.name }}</span> from <span class="font-semibold">{{ team.name }}</span>.
    </p>
    <p class="w-full my-6 sm:w-auto">
      What team do you wish to transfer them to?
    </p>
    <div class="w-full md:w-4/6 xl:w-1/2 my-8 mx-auto">
      <VDropdown
        :options="teamOptions"
        :sel-option="assignedTo"
        @select="selectTeam"
        placeholder="Select Team"
        class="w-full mx-auto"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import VDropdown from "@/components/Inputs/DropDown/VDropdown.vue"

export default {
  name: "MoveEmployeePrompt",
  components: {
    VDropdown,
  },
  emits: ["makeProceedPossible"],
  data() {
    return {
      movedToTeam: null,
      assignedTo: {
        name: null,
        id: null
      },
    }
  },
  computed: {
    ...mapGetters([
      "getProceedArgs",
      "siteTeams",
    ]),
    employee() {
      return this.getProceedArgs[0]
    },
    team() {
      return this.getProceedArgs[1]
    },
    allTeams() {
      return this.getProceedArgs[2]
    },
    teamOptions() {
      let options = []
      for (let teamId in this.siteTeams) {
        if (teamId === this.team.id) continue
        options.push({ id: teamId, name: this.siteTeams[teamId] })
      }
      return options
    },
  },
  mounted() {
    this.$emit("makeProceedPossible", false)
  },
  methods: {
    ...mapMutations(["selectManagerTeam"]),
    selectTeam(option) {
      this.assignedTo = option
      this.selectManagerTeam(option.id)
      this.$emit("makeProceedPossible", true)
    }
  },
}
</script>